import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import GroupSync from "models/interfaces/group-sync";

const defaultValues: GroupSync =
    RecordUtils.auditableDefaultValuesFactory<GroupSync>({
        jobId: null,
        externalIdentifier: undefined,
        name: "",
        parentGroupId: undefined,
        totalLicenses: 0,
        archivedOn: undefined,
    });

export default class GroupSyncRecord
    extends Record(defaultValues)
    implements GroupSync
{
    constructor(params?: GroupSync) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    public with(values: Partial<GroupSync>): GroupSyncRecord {
        return new GroupSyncRecord(Object.assign(this.toJS(), values));
    }
}
